 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		51: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		51: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"pages/cart/index/pages/delivery/_region/_category/pages/index/pages/menu/_name/_single/index/pages/m/cb842916","1":"pages/cart/index/pages/delivery/_region/_category/pages/index/pages/menu/_name/_single/index/pages/m/98b85bc3","3":"pages/delivery/_region/_category/pages/delivery/_region/index/pages/delivery/index/pages/delivery/ma/7021a248","4":"pages/delivery/_region/index/pages/delivery/index/pages/delivery/map","5":"pages/clearance/index/pages/profile/index","6":"pages/clearance/login/pages/login","7":"pages/index/pages/menu/_name/index","8":"pages/thankyoupage/_id/pages/thankyoupage/index","9":"vendors/pages/thankyoupage/_id/pages/thankyoupage/index","12":"pages/app/download","13":"pages/app/index","14":"pages/cart/index","15":"pages/clearance/index","16":"pages/clearance/login","17":"pages/contacts","18":"pages/delivery/_region/_category","19":"pages/delivery/_region/index","20":"pages/delivery/index","21":"pages/delivery/map","22":"pages/delivery/points/_slug","23":"pages/delivery/security","24":"pages/denied","25":"pages/gate","26":"pages/index","27":"pages/legal-info/_slug","28":"pages/legal-info/account-deleting","29":"pages/legal-info/index","30":"pages/legal-info/privacy-policy-courier","31":"pages/login","32":"pages/logout","33":"pages/menu/_name/_single/index","34":"pages/menu/_name/index","35":"pages/menu/index","36":"pages/news/_id","37":"pages/news/index","38":"pages/pizza-construct","39":"pages/postavshikam","40":"pages/profile/index","41":"pages/promo/_id","42":"pages/promo/index","43":"pages/promos/_id","44":"pages/promos/index","45":"pages/review/index","46":"pages/review/thankyou","47":"pages/thankyoupage/_id","48":"pages/thankyoupage/index","49":"pages/vacancies","50":"pages/vk","53":"vendors/pages/app/download","54":"vendors/pages/clearance/index"}[chunkId]||chunkId) + "." + {"0":"9825f9defb31","1":"9886e8704db8","2":"fb045c888a1e","3":"ddef56ed92db","4":"b28ccad73229","5":"a8c7901a0ca9","6":"6374bc42d9e8","7":"12ff01aecba7","8":"919623ba1577","9":"e0566b8475e7","12":"e2f1cdc4a5f3","13":"ec7a67dddd0a","14":"9f0fdc24d742","15":"79f62319bbab","16":"9d8f4f5ad7de","17":"08b49cc1b5fb","18":"73bce4616d70","19":"6f59034197f4","20":"f158d5e1420c","21":"fd4330ccbac2","22":"2d91a49f19f6","23":"b1bd42543481","24":"a3a51c6a0e97","25":"f7fd7535d00c","26":"2f38bdb5fe8d","27":"981b84dd088f","28":"919ca7654503","29":"4e6cc627921c","30":"3a3dc9e9ec10","31":"41387e23fc99","32":"3bfb4edc5c2e","33":"6ffaac80c9e7","34":"bb97d4b5bae7","35":"6b56ec271f85","36":"afeb6d3cc01c","37":"781605e24386","38":"d67430c4570f","39":"b074afc2bbed","40":"6e602f7b2c60","41":"57edd58447fd","42":"05e2ee69006e","43":"c6cc2fc61ef7","44":"5253158366e5","45":"4e162aa4ca1e","46":"f3086ff05d81","47":"efb6dedda1cd","48":"1da4913eba57","49":"e83b6464ca94","50":"63de3c1e2526","53":"722d7ccb18f0","54":"4fdfd203b5f5","55":"f70f8f1485f2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"29":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"54":1,"55":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"5e0f838037c2","1":"ec6acb38df64","2":"077676392faf","3":"3904af2fe4e2","4":"0f11a6290461","5":"2970d440754d","6":"51a4d8b170c7","7":"b6d5c655e12e","8":"302cf7a08ca8","9":"31d6cfe0d16a","12":"08a1c0af78ac","13":"6c520cada5d7","14":"0a4ef3ad4ecb","15":"309db4ff8785","16":"a96fec70a09f","17":"62fd4f3b5c71","18":"fd77955181a2","19":"a8ddb46a9d0a","20":"cb12b21db79b","21":"c881671a15d4","22":"0d8ea3535051","23":"b32484ab10cd","24":"7f20c0f498cd","25":"029941fc22df","26":"a569a44b8828","27":"31d6cfe0d16a","28":"31d6cfe0d16a","29":"5d3e5acafef6","30":"ea7f191ca4bd","31":"aafb69854c2d","32":"31d6cfe0d16a","33":"0b26ce1b7ffe","34":"ef586f4c8e9f","35":"27e6d464fb5e","36":"96d29a3a21db","37":"ca3c6485b6c1","38":"8aeab35decb8","39":"971d01e7beb0","40":"4225cf672171","41":"31d6cfe0d16a","42":"31d6cfe0d16a","43":"ae196ef315e0","44":"cbb1b1932bbd","45":"e45d07590d32","46":"ac630775b2e6","47":"55cdb8d2fa2c","48":"48e4646e89d5","49":"a11e8eb03584","50":"31d6cfe0d16a","53":"31d6cfe0d16a","54":"fb132983690b","55":"4af98cfb6ec7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"5e0f838037c2","1":"ec6acb38df64","2":"077676392faf","3":"3904af2fe4e2","4":"0f11a6290461","5":"2970d440754d","6":"51a4d8b170c7","7":"b6d5c655e12e","8":"302cf7a08ca8","9":"31d6cfe0d16a","12":"08a1c0af78ac","13":"6c520cada5d7","14":"0a4ef3ad4ecb","15":"309db4ff8785","16":"a96fec70a09f","17":"62fd4f3b5c71","18":"fd77955181a2","19":"a8ddb46a9d0a","20":"cb12b21db79b","21":"c881671a15d4","22":"0d8ea3535051","23":"b32484ab10cd","24":"7f20c0f498cd","25":"029941fc22df","26":"a569a44b8828","27":"31d6cfe0d16a","28":"31d6cfe0d16a","29":"5d3e5acafef6","30":"ea7f191ca4bd","31":"aafb69854c2d","32":"31d6cfe0d16a","33":"0b26ce1b7ffe","34":"ef586f4c8e9f","35":"27e6d464fb5e","36":"96d29a3a21db","37":"ca3c6485b6c1","38":"8aeab35decb8","39":"971d01e7beb0","40":"4225cf672171","41":"31d6cfe0d16a","42":"31d6cfe0d16a","43":"ae196ef315e0","44":"cbb1b1932bbd","45":"e45d07590d32","46":"ac630775b2e6","47":"55cdb8d2fa2c","48":"48e4646e89d5","49":"a11e8eb03584","50":"31d6cfe0d16a","53":"31d6cfe0d16a","54":"fb132983690b","55":"4af98cfb6ec7"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
